import { List as e } from "./components/List.es.js";
import { ListItem as t } from "./components/ListItem.es.js";
import "./components/index.es.js";
import { actionHandler as n } from "./lib/actionHandler.es.js";
import { normalizeNode as r } from "./lib/normalizeNode.es.js";
import { ListIcon as i } from "lucide-react";
import { jsx as a } from "react/jsx-runtime";
// lib/List/UnorderedList.tsx
var o = (o) => ({
	class: "text",
	name: "core/unordered-list",
	actions: [{
		name: "add-unordered-list",
		title: o?.title || "Bullet list",
		tool: () => /* @__PURE__ */ a(i, { style: {
			width: "1em",
			height: "1em"
		} }),
		hotkey: "mod+shift+8",
		handler: ({ editor: e }) => {
			n(e, "core/unordered-list");
		},
		visibility: (e, t) => {
			let n = t ?? e;
			return [
				[
					"core/ordered-list",
					"core/unordered-list",
					"core/text",
					"core/ordered-list/list-item",
					"core/unordered-list/list-item"
				].includes(n.type),
				!0,
				n.type === "core/unordered-list" || n.type === "core/unordered-list/list-item"
			];
		}
	}],
	componentEntry: {
		class: "text",
		component: e,
		constraints: { normalizeNode: (e, t) => r(e, t, "core/unordered-list") },
		children: [{
			type: "list-item",
			class: "text",
			component: t
		}]
	}
});
export { o as UnorderedList };
